import { render } from "./CommentComponent.vue?vue&type=template&id=13acdafd&scoped=true&ts=true"
import script from "./CommentComponent.vue?vue&type=script&lang=ts"
export * from "./CommentComponent.vue?vue&type=script&lang=ts"

import "./CommentComponent.vue?vue&type=style&index=0&id=13acdafd&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13acdafd"]])

export default __exports__